import EventActionItems from "./fields";

const EventAction = {
  Fields: EventActionItems
}

export default EventAction;